"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkipLink = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
require("./skipLink.css");
/** Skip link is a component that is only visible when you use the TAB to focus on it.  It allows the user to "jump" in a specific section. */
const SkipLink = ({ className, children, dataTest = 'link', ...other }) => {
    const classes = (0, classnames_1.default)('dsc-skipLink', className);
    return ((0, jsx_runtime_1.jsx)("a", { ...other, className: classes, "data-test": dataTest, children: children }));
};
exports.SkipLink = SkipLink;
exports.SkipLink.displayName = 'SkipLink';
//# sourceMappingURL=skipLink.js.map